<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#ccffdf;"><img src="assets/img/icons/section-salario-actual.svg" alt=""></span>
            <h5>Salario actual</h5>
        </div>

        <div class="d-flex align-items-center gap-4 mb-3">
            <label class="field-label mb-0">Jornada completa</label>
            <div class="field-checkbox-row">
                <input type="checkbox" id="full_time_yes" [checked]="form.get('full_time')?.value === true" (change)="setFullTime(true)">
                <label class="mb-0" for="full_time_yes">Si</label>
            </div>
            <div class="field-checkbox-row">
                <input type="checkbox" id="full_time_no" [checked]="form.get('full_time')?.value === false" (change)="setFullTime(false)">
                <label class="mb-0" for="full_time_no">No</label>
            </div>
        </div>

        <div class="field-columns">
            <div class="field-column">
                <div class="field-col">
                    <label class="field-label">Salario por dia</label>
                    <div class="field-input-plain" style="border:1px solid #dbdbdb;">
                        <input type="number" step="0.01" formControlName="daily_salary">
                        <i class="ti ti-help-circle"></i>
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Salario por hora</label>
                    <div class="field-input-plain">
                        <input type="number" step="0.01" formControlName="hourly_salary" readonly>
                        <i class="ti ti-help-circle"></i>
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Horas por dias</label>
                    <div class="field-input-plain">
                        <input type="number" step="0.01" formControlName="hours_per_day" readonly>
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Dias por semana</label>
                    <div class="field-input-plain">
                        <input type="number" formControlName="days_per_week" readonly>
                        <i class="ti ti-calendar"></i>
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Dias por periodo</label>
                    <div class="field-input-plain">
                        <input type="number" formControlName="days_per_period" readonly>
                        <i class="ti ti-calendar"></i>
                    </div>
                </div>
            </div>
            <div class="field-column">
                <div class="field-col">
                    <label class="field-label">Fecha de aplicacion</label>
                    <div class="field-input-plain" style="border:1px solid #dbdbdb;">
                        <app-date-picker formControlName="salary_effective_date"></app-date-picker>
                    </div>
                </div>
                <div class="field-col">
                    <label class="field-label">Forma de pago</label>
                    <select class="field-select" formControlName="payment_method">
                        <option value="">Seleccionar</option>
                        <option value="Efectivo">Efectivo</option>
                        <option value="Transferencia">Transferencia</option>
                        <option value="Cheque">Cheque</option>
                    </select>
                </div>

                <div formGroupName="restDays" class="rest-days-box">
                    <label class="field-label">Dias de descanso</label>
                    <div class="rest-days-grid">
                        <div class="field-checkbox-row" *ngFor="let day of restDayOptions">
                            <input type="checkbox" [id]="'rest_' + day.value" [formControlName]="day.value">
                            <label class="mb-0" [for]="'rest_' + day.value">{{day.label}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-card-grid-2">
        <div class="tab-card" style="margin-bottom: 0;">
            <div class="tab-card-header">
                <span class="tab-icon-badge" style="background:#defedb;"><img src="assets/img/icons/section-deposito-nomina.svg" alt=""></span>
                <h5>Depósito de nómina</h5>
            </div>
            <div class="field-col mb-3">
                <label class="field-label">Banco</label>
                <input type="text" class="field-input" formControlName="bank">
            </div>
            <div class="field-col mb-3">
                <label class="field-label">Numero de cuenta o tarjeta</label>
                <input type="text" class="field-input" formControlName="account_number">
            </div>
            <div class="field-col mb-3">
                <label class="field-label">Nombre del titular</label>
                <input type="text" class="field-input" formControlName="account_holder_name">
            </div>
            <div class="field-col">
                <label class="field-label">Tipo de cuenta</label>
                <select class="field-select" formControlName="account_type">
                    <option value="">Seleccionar</option>
                    <option value="Débito">Débito</option>
                    <option value="Tarjeta">Tarjeta</option>
                    <option value="Cuenta">Cuenta</option>
                </select>
            </div>
        </div>

        <div class="tab-card" style="margin-bottom: 0;">
            <div class="tab-card-header">
                <span class="tab-icon-badge" style="background:#ffecda;"><img src="assets/img/icons/section-prestaciones.svg" alt=""></span>
                <h5>Prestaciones y deducciones</h5>
            </div>
            <div class="field-col mb-3">
                <label class="field-label">No. FONACOT</label>
                <input type="text" class="field-input" placeholder="Ingresa el numero" formControlName="fonacot_number">
            </div>
            <div class="field-col">
                <label class="field-label">Tabla de vaciones</label>
                <input type="text" class="field-input" formControlName="vacation_table" readonly>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#d0dafb;"><img src="assets/img/icons/imss-tooth.svg" alt=""></span>
            <h5>IMSS</h5>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Base cotización</label>
                <select class="field-input" formControlName="imss_contribution_base_type">
                    <option value="">Seleccionar</option>
                    <option value="Fija">Fija</option>
                    <option value="Variable">Variable</option>
                    <option value="Mixta">Mixta</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">SDI calculado</label>
                <input type="number" step="0.01" class="field-input" formControlName="calculated_sdi" readonly>
            </div>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Tabla de SDI</label>
                <input type="text" class="field-input" formControlName="sdi_table" readonly>
            </div>
            <div class="field-col">
                <label class="field-label">SDI capturado</label>
                <input type="number" step="0.01" class="field-input" formControlName="entered_sdi">
            </div>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo('Editar')">
        <button type="submit" class="btn btn-primary">Guardar cambios</button>
    </div>
</form>
